import { Profile2User } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { StatisticCard } from '../../atoms/StatisticCard';
import { useGetTotalRevenueStatsQuery } from '@/store/services/reports';
import { useReportPeriod } from '@/store/slices/reportFiltersSlice';

export function Stats() {
  const { t } = useTranslation();
  const period = useReportPeriod();
  const { data: statisticsData } = useGetTotalRevenueStatsQuery(
    period ? { period } : undefined,
    { skip: !period }
  );

  const entries = Object.entries(statisticsData?.payload || {});

  return (
    <div className="space-y-6">
      <div className="col-span-2 grid gap-6 grid-cols-1 md:grid-cols-4">
        {entries.slice(0, 4).map(([key, value]) => (
          <StatisticCard
            key={key}
            title={t(`reports.budget.${key}`)}
            value={value as string | number}
            Icon={Profile2User}
            postfix={t('SAR')}
            formatted
          />
        ))}
      </div>

      {entries.length > 4 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {entries.slice(4).map(([key, value]) => (
            <StatisticCard
              key={key}
              title={t(`reports.budget.${key}`)}
              value={value as string | number}
              Icon={Profile2User}
              postfix={t('SAR')}
              formatted
            />
          ))}
        </div>
      )}
    </div>
  );
}
